import { Navigate } from "react-router-dom"
import { dashboardPath, loginPath } from "~/common/paths"
import { useViewerMaybe } from "../auth/use-viewer"

export const RootScreen = () => {
  const { viewer, result } = useViewerMaybe()

  if (result.loading) return null

  return <Navigate to={viewer ? dashboardPath({}) : loginPath({})} replace />
}
